import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { host } from '../../function/api'

const initialState = {
   
    Exhibitionperson: [],
    Exhibitionsuccess: false,
    Exhibitionstatus: false,
    Exhibitionloading: '',
    Exhibitionmessage: '',
    ExhibitionerrorName: '',
    ExhibitionerrorMobile: '',
    ExhibitionerrorCity: '',
    ExhibitionerrorFlag: '',
    ExhibitionerrorPassword: ''
}




export const ExhibitionuserUpdate = createAsyncThunk(
    'user/update',
    async (data, thunkAPI) => {
        try {
            console.log(data)
            const response = await axios({
                method: 'PATCH',
                url: `${host}user/${data.id}`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const ExhibitionfetchUser = createAsyncThunk(
    'fetch/user',
    async (user, thunkAPI) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}user/${user}`,
                data: user,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
const ExhibitionManagment = createSlice({
    name: 'ExhibitionManagment',
    initialState,
    reducers: {

    },
    extraReducers: {
      

        [ExhibitionuserUpdate.fulfilled]: (state, { payload }) => {
            state.Exhibitionloading = false;
            state.Exhibitionsuccess = true;
            state.Exhibitionstatus = true
            state.Exhibitionmessage = payload.message;
        },
        [ExhibitionuserUpdate.pending]: (state) => {
            state.Exhibitionloading = true;
            state.Exhibitionstatus = false
            state.Exhibitionsuccess = false;
            state.ExhibitionerrorName = ''
            state.ExhibitionerrorMobile = ''
            state.ExhibitionerrorFlag = ''
            state.ExhibitionerrorPassword = ''
        },
        [ExhibitionuserUpdate.rejected]: (state, { payload }) => {
            state.Exhibitionloading = false;
            state.Exhibitionsuccess = false;
            state.Exhibitionstatus = false
            state.Exhibitionmessage = payload.response.data.message;
            if (payload.response.data.error) {
                state.ExhibitionerrorName = payload.response.data.error.name
                state.ExhibitionerrorMobile = payload.response.data.error.mobile
                state.ExhibitionerrorFlag = payload.response.data.error.flag
                state.ExhibitionerrorPassword = payload.response.data.error.password
            } else {
                state.ExhibitionerrorName = ''
                state.ExhibitionerrorMobile = ''
                state.ExhibitionerrorFlag = ''
                state.ExhibitionerrorPassword = ''
            }
        },

        [ExhibitionfetchUser.fulfilled]: (state, action) => {
            state.Exhibitionloading = false;
            state.Exhibitionsuccess = true;
            state.Exhibitionstatus = true
            state.Exhibitionperson = action.payload.data
            state.Exhibitionmessage = action.payload.message
        },
        [ExhibitionfetchUser.pending]: (state) => {
            state.Exhibitionloading = true;
            state.Exhibitionsuccess = false;
            state.Exhibitionstatus = false
            state.Exhibitionperson = [];
        },
        [ExhibitionfetchUser.rejected]: (state, { payload }) => {
            state.Exhibitionloading = false;
            state.Exhibitionsuccess = false;
            state.Exhibitionstatus = false
            state.Exhibitionmessage = payload.response.data.message
        }
    }
})

export const { } = ExhibitionManagment.actions;
export default ExhibitionManagment.reducer;